module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/+app-custom/components/publication-registration/base-publication-form-part/author-form-part/author-form-part.component.scss
// module id = ./src/app/+app-custom/components/publication-registration/base-publication-form-part/author-form-part/author-form-part.component.scss
// module chunks = main